/**
 * EroticShop — Kategori Sayfası Etkileşimleri
 * collection-es.js v1.0
 *
 * Modüller:
 * 1. EsToast        — Bildirim toast'ı
 * 2. EsCartManager  — AJAX sepet işlemleri + cart count güncelleme
 * 3. EsQuickView    — "Hızlı Gör" modalı (sadece masaüstü ≥750px)
 * 4. EsMobileAtc    — Mobil "Sepete Ekle" form yönetimi
 * 5. Init           — DOMContentLoaded ile başlatma
 *
 * Bağımlılık: Sıfır (vanilla JS, ES6+)
 * Shopify API: /products/{handle}.js | /cart/add.js | /cart.js
 */

(function () {
  'use strict';

  /* Çoklu yüklemeye karşı guard — her kart render'ında script
     inject edilebilir; sadece ilk yükleme çalışır */
  if (window.__esCollectionLoaded) return;
  window.__esCollectionLoaded = true;

  /* ─── buradan itibaren mevcut kodun tamamı aynen devam eder ─── */

/* ─────────────────────────────────────────────────────
   YARDIMCI: Para birimi formatlama (TL)
───────────────────────────────────────────────────── */
const EsFormat = {
  /**
   * Shopify fiyatları kuruş (integer) cinsinden gelir.
   * Örnek: 12999 → "129,99 TL"
   */
  money(cents) {
  if (!cents && cents !== 0) return '';
  const amount = cents / 100;
  return amount.toLocaleString('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
  });
},

  /** HTML karakter kaçışı — XSS koruması */
  esc(str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;');
  },
};

/* ─────────────────────────────────────────────────────
   YARDIMCI: Sepet balonu (badge) tazeleme — tek kaynak
   Kök neden: Dawn, sepet boşken .cart-count-bubble'ı hiç
   render etmez → salt textContent patch'i ilk eklemede
   tutunacak eleman bulamaz, badge tepkisiz kalır.
   Çözüm: balon yoksa Section Rendering API'den
   cart-icon-bubble çekilir ve host'a swap edilir
   (fbt.js'te kanıtlanmış desen). header-init.js'teki
   MutationObserver özel ikonu otomatik yeniden uygular.
───────────────────────────────────────────────────── */
async function esRefreshCartBubble(count) {
  const host = document.getElementById('cart-icon-bubble');

  /* Sayfa genelindeki mevcut sayaçları her durumda patch'le */
  document
    .querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count]')
    .forEach((el) => { el.textContent = count; });
  document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
    bubble.classList.toggle('hidden', count === 0);
  });

  /* Balon DOM'da yok + sepette ürün var → server section'ı ile oluştur */
  if (!host || count === 0 || host.querySelector('.cart-count-bubble')) return;

  const res = await fetch(`${window.location.pathname}?sections=cart-icon-bubble`);
  if (!res.ok) throw new Error(`section HTTP ${res.status}`);

  const data = await res.json();
  const html = data['cart-icon-bubble'];
  if (!html) return;

  const fresh = new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector('.shopify-section');
  if (fresh) host.innerHTML = fresh.innerHTML;
}

/* ─────────────────────────────────────────────────────
   1. TOAST BİLDİRİM
───────────────────────────────────────────────────── */
class EsToast {
  constructor() {
    this._el = this._create();
    document.body.appendChild(this._el);
    this._timer = null;
  }

  _create() {
    const el = document.createElement('div');
    el.className = 'es-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    return el;
  }

  /**
   * Toast göster
   * @param {string} message  - Gösterilecek metin
   * @param {number} duration - Kaç ms görünür kalacak (default: 3000)
   */
  show(message, duration = 3000) {
    this._el.textContent = message;
    this._el.classList.add('is-visible');
    clearTimeout(this._timer);
    this._timer = setTimeout(() => {
      this._el.classList.remove('is-visible');
    }, duration);
  }
}

/* ─────────────────────────────────────────────────────
   2. AJAX SEPET YÖNETİCİSİ
───────────────────────────────────────────────────── */
class EsCartManager {
  constructor(toast) {
    this._toast = toast;
  }

  /**
   * Ürünü AJAX ile sepete ekler
   * @param {number} variantId
   * @param {number} quantity
   * @returns {Promise<object|null>} Eklenen ürün verisi veya null
   */
  async addItem(variantId, quantity = 1) {
    try {
      // Cart sayfasındaysak: Dawn section-rendering'i AYNI istekte iste.
      // Satır listesi + footer server HTML'iyle değişir; eklenen ürün anında
      // görünür ve line-index'ler server gerçeğiyle hizalanır (yanlış satır +/- biter).
      const itemsEl  = document.getElementById('main-cart-items');
      const footerEl = document.getElementById('main-cart-footer');

      const payload = { id: Number(variantId), quantity };
      if (itemsEl) {
        payload.sections = [itemsEl.dataset.id];
        if (footerEl) payload.sections.push(footerEl.dataset.id);
        payload.sections_url = window.location.pathname;
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.description || `HTTP ${res.status}`);
      }

      const item = await res.json();
      this._toast.show(`✓  "${EsFormat.esc(item.title)}" sepete eklendi`);

      // Cart sayfası: satır listesi (+ ücretsiz kargo barı) ve footer özetini değiştir
      if (itemsEl && item.sections) {
        this._renderCartSections(item, itemsEl, footerEl);

        // Boş sepet sayfasında ilk ekleme: Dawn empty-state'ini kapat.
        // is-empty kalırsa enjekte edilen satırlar (.cart__contents) ve
        // footer CSS ile gizli kalır, "Sepetiniz boş" görünmeye devam eder.
        // Ekleme her zaman adet>0 üretir → koşulsuz kaldırma güvenli;
        // sıfıra düşüş yönünü Dawn cart.js zaten yönetiyor (satır 178-182).
        const cartItemsEl = itemsEl.closest('cart-items');
        if (cartItemsEl) cartItemsEl.classList.remove('is-empty');
        if (footerEl) footerEl.classList.remove('is-empty');
      }
      this._refreshCartCount();
      return item;
    } catch (err) {
      console.error('[EsCart] Sepete ekleme hatası:', err.message);
      this._toast.show('Bir hata oluştu. Lütfen tekrar deneyin.');
      return null;
    }
  }

  /**
   * Dawn section HTML'ini cart sayfası DOM'una uygular (getSectionInnerHTML deseni).
   * main-cart-items .js-contents → satır listesi + ücretsiz kargo barı
   * main-cart-footer .js-contents → ara toplam / toplam özeti
   * <cart-items> elementi yerinde kaldığı için constructor'daki delege
   * change/click listener'ları korunur (Dawn updateQuantity ile aynı yaklaşım).
   */
  _renderCartSections(item, itemsEl, footerEl) {
    const apply = (host) => {
      if (!host) return;
      const html = item.sections[host.dataset.id];
      if (!html) return;
      const target = host.querySelector('.js-contents') || host;
      const fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.js-contents');
      if (fresh) target.innerHTML = fresh.innerHTML;
    };
    apply(itemsEl);
    apply(footerEl);
  }

  /**
   * Sepet adet göstergesini günceller — tek kaynak: esRefreshCartBubble.
   * Balon DOM'da yoksa (sayfa boş sepetle açıldıysa) server section'ından
   * oluşturur; varsa sayıyı patch'ler.
   */
  async _refreshCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      // Badge güncelleme tek kaynağa devredildi — ilk ekleme senaryosu dahil
      await esRefreshCartBubble(cart.item_count);

      // Cross-sell vb. abonelere haber ver (re-filter). source:'cart-items' →
      // Dawn CartItems satır listesini TEKRAR render etmez (biz zaten ettik).
      if (typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
      }
    } catch {
      // Sayım güncellenemezse kullanıcıya etki etmez, sessizce geç
    }
  }
}

/* ─────────────────────────────────────────────────────
   3. QUICK VIEW MODALI
   Trendyol "Hızlı Gör" yaklaşımı — sadece masaüstü
───────────────────────────────────────────────────── */
class EsQuickView {
  constructor(cartManager) {
    this._cart = cartManager;
    this._overlay = null;
    this._selectedVariantId = null;
    this._isLoading = false;
    this._init();
  }

  _init() {
    // Overlay container — bir kez oluştur, içeriği her açılışta güncelle
    this._overlay = document.createElement('div');
    this._overlay.className = 'es-qv-modal-overlay';
    this._overlay.setAttribute('role', 'dialog');
    this._overlay.setAttribute('aria-modal', 'true');
    this._overlay.setAttribute('aria-label', 'Hızlı Ürün Görünümü');
    this._overlay.setAttribute('tabindex', '-1');
    document.body.appendChild(this._overlay);

    // ESC tuşuyla kapat
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this._overlay.classList.contains('is-open')) {
        this.close();
      }
    });

    // Overlay (arka plan) tıklamasıyla kapat
    this._overlay.addEventListener('click', (e) => {
      if (e.target === this._overlay) this.close();
    });

    // Event delegation — tüm "Hızlı Gör" butonlarını dinle
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.es-qv-btn');
      if (!btn) return;
      e.preventDefault();
      const handle = btn.dataset.productHandle;
      const url = btn.dataset.productUrl;
      if (handle) this.open(handle, url);
    });
  }

  /**
   * Modalı açar: ürün verisini çeker ve render eder
   * @param {string} handle     - Shopify ürün handle
   * @param {string} productUrl - Ürün sayfa URL'i (yönlendirme linki için)
   */
  async open(handle, productUrl) {
    if (this._isLoading) return;
    this._isLoading = true;

    // Önce loading durumunu göster
    this._showLoading();
    document.body.style.overflow = 'hidden';

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const product = await res.json();
      this._render(product, productUrl);
    } catch (err) {
      console.error('[EsQuickView] Ürün yükleme hatası:', err.message);
      this._showError(productUrl);
    } finally {
      this._isLoading = false;
    }
  }

  /** Loading skeleton göster, overlay aç */
  _showLoading() {
    this._overlay.innerHTML = `
      <div class="es-qv-modal" role="document">
        ${this._closeBtnHtml()}
        <div class="es-qv-loading" aria-live="polite" aria-label="Yükleniyor">
          Yükleniyor…
        </div>
      </div>
    `;
    this._overlay.classList.add('is-open');
    this._bindCloseBtn();
    // Erişilebilirlik: modalı fokusla
    setTimeout(() => this._overlay.focus(), 50);
  }

  /** Hata durumunu göster */
  _showError(productUrl) {
    const errEl = this._overlay.querySelector('.es-qv-loading');
    if (errEl) {
      errEl.innerHTML = `
        Ürün yüklenirken bir hata oluştu.
        <a href="${EsFormat.esc(productUrl)}" class="es-qv-modal__view-link" style="display:inline;margin-left:0.4rem">
          Ürün sayfasını aç →
        </a>
      `;
    }
  }

  /**
   * Ürün verisini alarak modal içeriğini oluşturur
   * @param {object} product    - /products/{handle}.js yanıtı
   * @param {string} productUrl - Ürün sayfa URL'i
   */
  _render(product, productUrl) {
    const firstVariant = product.variants[0];
    this._selectedVariantId = firstVariant.id;

    const hasMultipleVariants = product.variants.length > 1;
    const imgSrc = product.featured_image
      ? `${product.featured_image}&width=600`
      : '';

    this._overlay.innerHTML = `
      <div class="es-qv-modal" role="document">
        ${this._closeBtnHtml()}

        <div class="es-qv-modal__image">
          ${imgSrc
            ? `<img
                id="es-qv-img"
                src="${EsFormat.esc(imgSrc)}"
                alt="${EsFormat.esc(product.title)}"
                width="600"
                height="600"
                loading="eager"
              >`
            : '<span style="color:#ccc;font-size:1.3rem">Görsel yok</span>'
          }
        </div>

        <div class="es-qv-modal__details">
          <h2 class="es-qv-modal__title">${EsFormat.esc(product.title)}</h2>

          <div class="es-qv-modal__price" id="es-qv-price">
            ${this._priceHtml(firstVariant.price, firstVariant.compare_at_price)}
          </div>

          ${hasMultipleVariants ? this._variantsHtml(product.variants, firstVariant.id) : ''}

          <div class="es-qv-modal__qty" aria-label="Miktar seçici">
            <button class="es-qv-qty-btn" data-action="minus" type="button" aria-label="Azalt">−</button>
            <input
              class="es-qv-qty-input"
              id="es-qv-qty"
              type="number"
              value="1"
              min="1"
              max="99"
              aria-label="Ürün miktarı"
            >
            <button class="es-qv-qty-btn" data-action="plus" type="button" aria-label="Artır">+</button>
          </div>

          <button
            class="es-qv-modal__add-btn"
            id="es-qv-add"
            type="button"
            ${firstVariant.available ? '' : 'disabled'}
          >
            ${firstVariant.available ? 'Sepete Ekle' : 'Stokta Yok'}
          </button>

          <a class="es-qv-modal__view-link" href="${EsFormat.esc(productUrl)}">
            Ürün detayına git →
          </a>
        </div>
      </div>
    `;

    this._bindCloseBtn();
    this._bindVariants();
    this._bindQty();
    this._bindAddToCart();
  }

  /** Fiyat HTML'i — indirimli fiyatı da göster */
  _priceHtml(price, compareAt) {
    const hasDiscount = compareAt && compareAt > price;
    return `
      <span class="es-qv-modal__price-current">${EsFormat.money(price)}</span>
      ${hasDiscount
        ? `<span class="es-qv-modal__price-compare">${EsFormat.money(compareAt)}</span>`
        : ''}
    `;
  }

  /** Varyant butonları HTML'i */
  _variantsHtml(variants, activeId) {
    const btns = variants.map((v) => `
      <button
        class="es-qv-variant-btn${v.id === activeId ? ' is-active' : ''}"
        type="button"
        data-variant-id="${v.id}"
        data-variant-price="${v.price}"
        data-variant-compare="${v.compare_at_price || 0}"
        data-variant-image="${v.featured_image ? EsFormat.esc(v.featured_image.src) : ''}"
        data-variant-available="${v.available}"
        aria-pressed="${v.id === activeId}"
        ${!v.available ? 'disabled' : ''}
      >
        ${EsFormat.esc(v.title)}
      </button>
    `).join('');

    return `
      <div class="es-qv-modal__variants" id="es-qv-variants" role="group" aria-label="Ürün seçenekleri">
        ${btns}
      </div>
    `;
  }

  /** Kapatma butonu HTML'i (paylaşılan) */
  _closeBtnHtml() {
    return `
      <button class="es-qv-modal__close" type="button" aria-label="Modalı kapat">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    `;
  }

  /** Kapatma butonunu bağla (render sonrası her çağrılır) */
  _bindCloseBtn() {
    this._overlay.querySelector('.es-qv-modal__close')
      ?.addEventListener('click', () => this.close());
  }

  /** Varyant seçim etkileşimi */
  _bindVariants() {
    const container = this._overlay.querySelector('#es-qv-variants');
    if (!container) return;

    container.addEventListener('click', (e) => {
      const btn = e.target.closest('.es-qv-variant-btn');
      if (!btn || btn.disabled) return;

      // Aktif state güncelle
      container.querySelectorAll('.es-qv-variant-btn').forEach((b) => {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      this._selectedVariantId = parseInt(btn.dataset.variantId, 10);
      const price    = parseInt(btn.dataset.variantPrice, 10);
      const compare  = parseInt(btn.dataset.variantCompare, 10);
      const available = btn.dataset.variantAvailable === 'true';
      const imgSrc   = btn.dataset.variantImage;

      // Fiyatı güncelle
      const priceEl = this._overlay.querySelector('#es-qv-price');
      if (priceEl) priceEl.innerHTML = this._priceHtml(price, compare);

      // Varyant görseli varsa değiştir
      if (imgSrc) {
        const img = this._overlay.querySelector('#es-qv-img');
        if (img) img.src = `${imgSrc}&width=600`;
      }

      // Sepete Ekle butonunu güncelle
      const addBtn = this._overlay.querySelector('#es-qv-add');
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Sepete Ekle' : 'Stokta Yok';
      }
    });
  }

  /** Miktar (+/-) kontrolü */
  _bindQty() {
    const input = this._overlay.querySelector('#es-qv-qty');
    const qtyWrapper = this._overlay.querySelector('.es-qv-modal__qty');
    if (!input || !qtyWrapper) return;

    qtyWrapper.addEventListener('click', (e) => {
      const btn = e.target.closest('.es-qv-qty-btn');
      if (!btn) return;
      let val = parseInt(input.value, 10) || 1;
      if (btn.dataset.action === 'plus')  val = Math.min(val + 1, 99);
      if (btn.dataset.action === 'minus') val = Math.max(val - 1, 1);
      input.value = val;
    });

    // Manuel giriş doğrulama
    input.addEventListener('change', () => {
      let val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (val > 99) val = 99;
      input.value = val;
    });
  }

  /** Sepete Ekle butonu */
  _bindAddToCart() {
    const addBtn = this._overlay.querySelector('#es-qv-add');
    if (!addBtn) return;

    addBtn.addEventListener('click', async () => {
      if (!this._selectedVariantId) return;

      const qty = parseInt(this._overlay.querySelector('#es-qv-qty')?.value, 10) || 1;

      addBtn.disabled = true;
      addBtn.textContent = 'Ekleniyor…';

      const result = await this._cart.addItem(this._selectedVariantId, qty);

      if (result) {
        // Başarılı: modalı kapat, toast gösterildi (EsCartManager içinde)
        this.close();
      } else {
        // Başarısız: butonu geri al
        addBtn.disabled = false;
        addBtn.textContent = 'Sepete Ekle';
      }
    });
  }

  /** Modalı kapat */
  close() {
    this._overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    // Animasyon bitince içeriği temizle (bellek yönetimi)
    setTimeout(() => {
      if (!this._overlay.classList.contains('is-open')) {
        this._overlay.innerHTML = '';
        this._selectedVariantId = null;
      }
    }, 300);
  }
}

/* ─────────────────────────────────────────────────────
   4. MOBİL SEPETE EKLE
   Form submit'i AJAX'a çevirir, sayfa yenilemez
───────────────────────────────────────────────────── */
class EsMobileAtc {
  constructor(toast) {
    this._toast = toast;
    this._init();
  }

  _init() {
    // Event delegation — tüm mobil ATC formlarını dinle
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('.es-mobile-atc__form');
      if (!form) return;
      e.preventDefault();

      const btn = form.querySelector('button[type="submit"]');
      const variantId = form.querySelector('input[name="id"]')?.value;
      if (!variantId || !btn) return;

      // Çift tıklamayı engelle
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Ekleniyor…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        // Başarı durumu — kısa süre göster
        btn.classList.add('is-success');
        btn.textContent = '✓  Eklendi';
        this._toast.show('Ürün sepete eklendi');
        this._refreshCartCount();

        setTimeout(() => {
          btn.textContent = 'Sepete Ekle';
          btn.classList.remove('is-success');
          btn.disabled = false;
        }, 2200);
      } catch {
        this._toast.show('Bir hata oluştu. Lütfen tekrar deneyin.');
        btn.textContent = 'Sepete Ekle';
        btn.disabled = false;
      }
    });
  }

  /** Sepet adet göstergesini güncelle */
  async _refreshCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      await esRefreshCartBubble(cart.item_count);
    } catch {
      // Sayım güncellenemezse kullanıcıya etki etmez, sessizce geç
    }
  }
}

/* ─────────────────────────────────────────────────────
   5. BAŞLAT
───────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  const toast = new EsToast();
  const cart  = new EsCartManager(toast);

  // Quick View: her zaman başlat. Pill/modal zaten <750px'de CSS ile gizli;
  // gate'i kaldırmak, mobil↔masaüstü geçişinde "pill var ama ölü" durumunu önler.
  new EsQuickView(cart);

  // Mobil ATC: her zaman başlat (mobil ekranlarda form var, masaüstünde CSS ile gizli)
  new EsMobileAtc(toast);
});

})(); /* IIFE kapanışı */
